/* app/js/src/components/user/add-new-user/add-new-user.component.scss */
.loadingMessage {
  text-align: center;
  line-height: 760px;
}
.sideMenu {
  width: 187px;
  min-height: 405px;
  border-right: 1px solid #879baf;
  display: inline-block;
  margin-left: 50px;
}
.sideMenu .menu-item {
  margin-bottom: 40px;
}
.user-form {
  width: 100%;
  padding-left: 320px;
  padding-right: 320px;
  margin-top: 10px;
}
.buttons {
  padding-left: 218px;
}
.title {
  color: #232f3a;
  background-color: white;
  height: 40px;
  margin-top: 0px;
  padding-left: 44px;
}
.title span {
  font-size: 30px;
  font-weight: bold;
  padding-left: 150px;
  vertical-align: middle;
}
.row-header {
  color: #232f3a;
}
/*# sourceMappingURL=add-new-user.component.css.map */
